module.exports = __webpack_public_path__ + "static/media/intro-photowall-16.bde23a26.jpg";